import React, { Component } from 'react';
import {getBrokenCoupons} from '../../modules/Api';
import ReactTable from 'react-table';
import history from '../../modules/History';
import { Button, notification } from 'antd';
import { END_POINT } from '../../constants/config';
import ACL from '../../components/ACL';
class BrokenCoupons extends Component {
    constructor() {
        super();
        this.state = {
            items: [],
            pageSize: 15,
            count: 0,
            last_page: 1,
        }
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData = (query = '') => {
        getBrokenCoupons(query, (res) => {this.setState({
            items: res.data.data,
            last_page: res.data.last_page,
            count: res.data.total,
            pageSize: res.data.per_page
        })});
    }

    onChange(state) {
        this.setState({pageSize: state.pageSize});
        let sort = {
            order: 'desc',
            field: 'created_at',
        };
        if(state.sorted.length > 0) {
            sort = {
                order: state.sorted[0].desc ? 'desc': 'asc',
                field: state.sorted[0].id,
            }
        }

        let filterQuery = state.filtered.reduce((q, item) => {
            return item.value ? `${q}&${item.id}=${item.value}` : q;
        }, '');

        const query = `page=${state.page  + 1}&per_page=${state.pageSize}&${filterQuery}&sort=${JSON.stringify(sort)}`;
        this.fetchData(query);
    }


    render() {
        const columns = [
            {
                Header: ' آیدی کوپن',
                accessor: 'coupon.mpn_id',
                filterable: false,
                Cell: (row) => (<ACL component="div" has_permission="coupons_management|coupons_edit"><span style={{color: 'rgb(39, 105, 125)', cursor: 'pointer'}} title={row.original.coupon.mpn_id} onClick={() => {window.open(`/coupons/edit/${row.original.coupon.mpn_id}`, "_blank")}}> {row.original.coupon.mpn_id} </span></ACL>)

            },
            {
                Header: ' کوپن',
                accessor: 'coupon.title',
                filterable: false,
                Cell: (row) => (<ACL component="div" has_permission="coupons_management|coupons_edit"><span style={{color: 'rgb(39, 105, 125)', cursor: 'pointer'}} title={row.original.coupon.mpn_id} onClick={() => {window.open(`/coupons/edit/${row.original.coupon.mpn_id}`, "_blank")}}> {row.original.coupon.title} </span></ACL>)

            },
            {
                Header: 'تعداد دفعات گزارش',
                accessor: 'count',
                filterable: false,
                Cell: (row) => (<ACL component="div" has_permission="coupons_management|coupons_edit"><span style={{color: 'rgb(39, 105, 125)', cursor: 'pointer'}} title={row.original.coupon.mpn_id} onClick={() => {window.open(`/coupons/edit/${row.original.coupon.mpn_id}`, "_blank")}}> {row.original.count} </span></ACL>)
            }

        ]
        return(
            <div style={{textAlign: 'center'}}>
            
                <ReactTable
                    data={this.state.items}
                    columns={columns}
                    manual
                    onFetchData={(state) => {this.onChange(state)}}
                    defaultPageSize={parseInt(this.state.pageSize, 10)}
                    pages={this.state.last_page}/>
            </div>
        );
    }
}

export default BrokenCoupons;



// WEBPACK FOOTER //
// ./src/containers/BrokenCoupons/index.js